export const START_TIMER = 'startTimer'
export const UPDATE_TIME = 'updateTime'
export const INVALIDATE_CACHE = 'invalidateCache'
export const CLEAR_WAITING_PROMISES = "clearWaitingPromises"
